import Cookies from 'js-cookie'
export default function auth ({ next }){
  if (!Cookies.get('auth_token')) {
    return next({
      name: 'login'
    })
  }

  return next()
}